import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import { Triangle } from "react-loader-spinner";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import SalesReportService from "../../../services/OrderingServices/SalesReportService";
// import NumberWithCommas from "../../../pages/Pages/Starter/NumberWithCommas";

const CategoryWiseReport = () => {
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);

  // filters
  const [filterText, setFilterText] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);

  // Format helper
  const formatDate = (date) => date?.toLocaleDateString("en-CA");

  // Fetch data
  const fetchData = async (from = fromDate, to = toDate, category = filterText) => {
    if (!from || !to) {
      alert("Please select both From and To dates");
      return;
    }

    setLoading(true);
    try {
      const response = await SalesReportService.categoryWise({
        categoryName: category,
        fromDate: formatDate(from),
        toDate: formatDate(to),
      });
      setAllData(response || []);
    } catch (error) {
      console.error("Error fetching data:", error);
      setAllData([]);
    } finally {
      setLoading(false);
    }
  };

  // Initialize 1-month range on mount + auto-fetch
  useEffect(() => {
    const today = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(today.getMonth() - 1);

    setFromDate(lastMonth);
    setToDate(today);

    fetchData(lastMonth, today, ""); // fetch all categories initially
  }, []);

  // Auto-fetch when category filter changes
  useEffect(() => {
    if (fromDate && toDate) {
      fetchData(fromDate, toDate, filterText);
    }
  }, [filterText]); // only trigger on filterText change

  // totals
  const totalQuantity = allData.reduce((sum, item) => sum + item.totalQuantity, 0);
  const totalSales = allData.reduce((sum, item) => sum + item.totalSales, 0);

  return (
    <div>
      <Card className="shadow-sm mb-4">
        <CardBody>
          {/* Filters */}
          <Row className="mb-4 align-items-end">
            <Col md={3} className="mb-2">
              <input
                type="text"
                className="form-control"
                placeholder="Filter by Category Name"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
              />
            </Col>
            <Col md={2} className="mb-2">
              <Flatpickr
                options={{ dateFormat: "Y-m-d" }}
                value={fromDate}
                onChange={(dates) => setFromDate(dates[0])}
                className="form-control"
                placeholder="From Date"
              />
            </Col>
            <Col md={2} className="mb-2">
              <Flatpickr
                options={{ dateFormat: "Y-m-d" }}
                value={toDate}
                onChange={(dates) => setToDate(dates[0])}
                className="form-control"
                placeholder="To Date"
              />
            </Col>
            <Col md={2} className="mb-2">
              <Button color="primary" className="w-100" onClick={() => fetchData()}>
                Generate
              </Button>
            </Col>
          </Row>

          {/* Table */}
          {loading ? (
            <div className="my-5 text-center d-flex flex-column align-items-center">
              <Triangle visible={true} height="80" width="80" color="#5B71B9" ariaLabel="triangle-loading" />
              <h5 className="mt-3">Loading...</h5>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-primary sticky-top">
                  <tr>
                    <th style={{ width: "60px" }}>SN</th>
                    <th>Category Name</th>
                    <th style={{ width: "150px" }} className="text-end">
                      Total Quantity
                    </th>
                    <th style={{ width: "150px" }} className="text-end">
                      Total Sales
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allData.length > 0 ? (
                    allData.map((item, index) => (
                      <tr key={item.categoryId}>
                        <td>{index + 1}</td>
                        <td>{item.categoryName}</td>
                        <td className="text-end">{item.totalQuantity}</td>
                        <td className="text-end"><NumberWithCommas number={item.totalSales} /></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="text-center">No data available</td>
                    </tr>
                  )}
                </tbody>
                {allData.length > 0 && (
                  <tfoot>
                    <tr className="table-secondary fw-bold text-end">
                      <td colSpan="2">Total</td>
                      <td>{totalQuantity}</td>
                      <td><NumberWithCommas number={totalSales} /></td>
                    </tr>
                  </tfoot>
                )}
              </table>
            </div>
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default CategoryWiseReport;